import { AppBar } from '@material-ui/core';
import { Linked } from '@type-r/react';
import * as React from 'react';
import { Flex, SearchInput, Toolbar} from 'lqx-react';

export interface OrderSortOptions {
    attr : string
    asc : boolean
}

export interface SearchToolbarProps {
    $filter : Linked<string>
    $sort : Linked<OrderSortOptions>
    sortOptions : { [ attr : string ] : string }
}

export const SearchToolbar = ({ sortOptions, $filter, $sort } : SearchToolbarProps ) =>
    <AppBar position="static" color="transparent">
        <Toolbar>
            <SearchInput
                placeholder="Search"
                $value={ $filter }
            />

            <Flex grow />

        </Toolbar>
    </AppBar>

